"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "title"
  }, [!_vm.isBlocked ? _c("h1", {
    staticClass: "title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v("\n        Cadastro de cliente\n      ")]) : _c("h1", {
    staticClass: "title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v("\n        " + _vm._s(_vm.clientForm.businessName) + "\n      ")])]), _vm._v(" "), _c("div", {
    staticClass: "header-tab-options"
  }, _vm._l(_vm.steps, function (step, index) {
    return _c("div", {
      key: index,
      class: {
        active: _vm.activeStep === index
      }
    }, [_c("b-button", {
      on: {
        click: function click($event) {
          return _vm.setTab(index);
        }
      }
    }, [_vm._v("\n          " + _vm._s(step.label) + "\n        ")])], 1);
  }), 0), _vm._v(" "), _vm.activeStep === 0 && !_vm.loading ? _c("client-data-form", {
    attrs: {
      next: _vm.next,
      "client-form": _vm.clientForm
    },
    on: {
      "update:clientForm": function updateClientForm($event) {
        _vm.clientForm = $event;
      },
      "update:client-form": function updateClientForm($event) {
        _vm.clientForm = $event;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeStep === 1 ? _c("client-document-form", {
    attrs: {
      next: _vm.next
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeStep === 2 ? _c("client-businessunit-form", {
    attrs: {
      next: _vm.next
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeStep === 3 ? _c("client-onboarding-form", {
    attrs: {
      next: _vm.next
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;